import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EnquiryForm from "@/components/EnquiryForm";

const EnquiryContext = createContext({ openEnquiry: () => {} });

export const useEnquiry = () => useContext(EnquiryContext);

export function EnquiryProvider({ children }) {
  const [preset, setPreset] = useState(null);

  const openEnquiry = (opts = {}) => setPreset({ tripType: "Other", ...opts });
  const close = () => setPreset(null);

  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <Dialog open={!!preset} onOpenChange={(o) => !o && close()}>
        <DialogContent data-testid="enquiry-modal" className="max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl" data-lenis-prevent>
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-bold text-navy">Request a Tailor-Made Quote</DialogTitle>
            <DialogDescription className="text-slate-500">
              All costing is on request — it depends on your travel dates, hotel category, flights, number of travellers and customised requirements.
            </DialogDescription>
          </DialogHeader>
          {preset && <EnquiryForm preset={preset} onDone={close} />}
        </DialogContent>
      </Dialog>
    </EnquiryContext.Provider>
  );
}
